import styles from "./LogoWall.module.css";
import { LOGO_VERSION, withVersion } from "../../lib/assetVersions.js";

export default function LogoWall({ clients, label = "Our clients" }) {
  const track = (duplicate) => (
    <ul className={styles.track} aria-hidden={duplicate || undefined}>
      {clients.map((c) => (
        <li key={`${c.logo}${duplicate ? "-dup" : ""}`} className={styles.item}>
          <picture>
            <source type="image/webp" srcSet={withVersion(`${c.logo}-mono.webp`, LOGO_VERSION)} />
            <img
              src={withVersion(`${c.logo}-mono.png`, LOGO_VERSION)}
              alt={duplicate ? "" : c.name}
              height="48"
              loading="lazy"
              decoding="async"
            />
          </picture>
        </li>
      ))}
    </ul>
  );
  return (
    <div className={styles.wall} role="region" aria-label={label}>
      <div className={styles.marquee}>
        {track(false)}
        {track(true)}
      </div>
    </div>
  );
}
